import React from 'react';
export function AboutPage() {
  const font = "'Helvetica Neue', Helvetica, Arial, sans-serif";
  return <main className="w-full bg-white px-4 sm:px-6 md:px-12 pt-16 pb-32" style={{
    fontFamily: font
  }} data-id="element-92">
      {/* Heading */}
      <h1 className="text-[32px] sm:text-[42px] md:text-[56px] font-normal text-black mb-12 sm:mb-16 md:mb-24 tracking-tight" data-id="element-93">
        Why tho?
      </h1>

      {/* "Because" label - full width */}
      <h2 className="text-[13px] font-bold text-black mb-4" data-id="element-94">Because</h2>

      {/* Divider - full width */}
      <div className="w-full h-[1px] bg-gray-300 mb-8" data-id="element-95"></div>

      {/* Two-column content below the divider */}
      <div className="flex flex-col md:flex-row gap-2 md:gap-16" data-id="element-96">
        <div className="max-w-xl flex-shrink-0" data-id="element-97">
          <div className="flex flex-col" data-id="element-98">
            <div className="space-y-8" data-id="element-99">
              <p className="text-[16px] leading-[1.6] text-black" data-id="element-100">
                If you work remotely, travel often, or live between cities,
                chances are you're a child of the internet. Your friends are
                scattered across the world. Your community lives in group chats.
                The internet raised you, but it never gave you a home. What if
                it could?
              </p>

              <p className="text-[16px] leading-[1.6] text-black" data-id="element-101">
                Post-Strangers is a global dinner series spawned from Plumia x
                Nomad Citizen. Plumia Country is the nation. Nomad Citizen
                provides the state infrastructure.
              </p>

              <p className="text-[16px] leading-[1.6] text-black" data-id="element-102">
                Here, we're building the culture of the internet, offline. We
                believe that big networks only work when they're grounded in
                small, high trust groups first. So we start with dinner, 10
                people, personal stories, and genuine familiarity. You leave
                with peers who become supporters, collaborators, friends.
              </p>

              <p className="text-[16px] leading-[1.6] text-black" data-id="element-103">
                For our first year, all dinners are free. After that, seats will
                be reserved for members only. So pull up a chair while the
                table's open.
              </p>

              <p className="text-[16px] leading-[1.6] text-black" data-id="element-104">
                F* networking. We're nation building, and we're starting with
                one dinner at a time.
              </p>

              <p className="text-[16px] leading-[1.6] text-black" data-id="element-105">
                For more details on select works, visit the Dinners page.
              </p>
            </div>

            <div className="mt-16" data-id="element-106">
              <h3 className="text-[13px] text-gray-400 mb-2" data-id="element-107">Locations</h3>
              <p className="text-[15px] text-black font-medium" data-id="element-108">
                Hong Kong, Thailand, Indonesia, Portugal, Taiwan, Portugal &
                France
              </p>
            </div>
          </div>
        </div>

        {/* Image on the right - below the divider */}
        <div className="flex-1 flex items-start justify-center overflow-hidden order-first md:order-last md:mb-0" data-id="element-109">
          <img src="https://cdn.magicpatterns.com/uploads/ojyACq8no7omXSJ2xSr7hY/one_thing_i_wish_i_had_access_to_but_dont_is..._(15).png" alt="Plumia Policy Paper - Shaping a Global Standard for Digital Nomad Visas" draggable={false} className="about-image-mobile-crop w-[150%] max-w-none md:w-auto md:max-w-full md:-mt-[25%]" data-id="element-110" />
        </div>
      </div>
    </main>;
}